import { Button as MUIButton } from '@mui/material';
import React from 'react'

export default function Button(props) {
    const { text, size, color, variant, onClick, ...rest } = props;
    return (
        <MUIButton
            variant={variant || "contained"}
            size={size || "large"}
            color={color}
            onClick={onClick}
            {...rest}
        >
            {text}
        </MUIButton>
    )
}
